import React from 'react'
import renderRoutes from 'core/routes/renderRoutes'
import WindowDefault from 'components/Windows/WindowDefault'

const ParcelDestinationContainer = (props) => {
  const { route, business, location, windowModal, closeWindowModal } = props

  return (
    <WindowDefault windowModal={windowModal}>
      { renderRoutes({
        routes: route.routes,
        extraProps: { business, windowModal, closeWindowModal },
        location
      }) }
    </WindowDefault>
  )
}

export default ParcelDestinationContainer
